import { createClient } from '@supabase/supabase-js';
import { getSession } from './auth.js';

const SUPABASE_URL = (import.meta as any).env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = (import.meta as any).env.VITE_SUPABASE_ANON_KEY;

let _client: any = null;

export function getSupabaseRealtimeClient() {
  if (!_client) {
    _client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
      },
    });
  }
  const session = getSession();
  if (session?.access_token) {
    _client.realtime.setAuth(session.access_token);
  }
  return _client;
}
